"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssessment = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var risk_1 = require("../../model/risk");
var service_1 = require("../../../library/base/service");
var GetAssessment = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetAssessment, _super);
    function GetAssessment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '风险测评题目获取接口';
        _this.code = '101049';
        _this.desc = '风险测评题目获取接口';
        _this.requestParams = new risk_1.GetAssessmentRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetAssessment;
}(service_1.BaseService));
exports.GetAssessment = GetAssessment;
//# sourceMappingURL=getAssessment.js.map